/* global toastr:false, moment:false */
(function() {
    'use strict';

    angular
        .module('app.core')
        .constant('toastr', toastr)
        .constant('moment', moment)
        .constant('_', _);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/core/constants.js
 ** module id = 151
 ** module chunks = 0
 **/